import { MapResponse } from '@empathy/search-adapter';
import { Filter } from '@empathy/search-types';

export const mapFilterColorUrl: MapResponse<any, Filter> = (rawFilter, filter) => {
  if (rawFilter.url) {
    Object.assign(filter, { colorUrl: rawFilter.url });
  }
  return filter;
};
